import React from "react";

// 🔷 Components Import
import Newhome from "./Newhome"; // Header + Banner

import Newhomefooter from "./Newhomefooter";
import SitemapPage from "./Sitemap";

const Sitemappage = () => {
  return (
    <>
    <div className="home-page-new">
      {/* 🔷 HEADER + HERO */}
      <Newhome />

      {/* 🔷 Screen Reader */}
    
      <SitemapPage />
      <Newhomefooter />
      </div>
    </>
  );
};

export default Sitemappage;